import { IAppState } from '../../redux';
import { ITermsDuration } from '../../redux/reducers';

export function selectTermsDurations(state: IAppState): ITermsDuration[] {
  return state.termsDurations.durations;
}
